/**
 * Transforms a search term into a URL-safe SEO-adjusted representation.
 */
export const encodeSearchTerm = (searchTerm: string) =>
  encodeURIComponent(searchTerm.trim().replace(/[\s]+/g, '+')).replace('%2B', '+');

/**
 * Transforms a search term representation from a URL to a human-readable string.
 */
export const decodeSearchTerm = (searchTerm: string) =>
  decodeURIComponent(searchTerm).replace(/\+/g, ' ');
